import { useIntl } from 'react-intl';
import type TrailRouteType from '@alltrails/trails/types/TrailRouteType';
import getTrailRouteTypeLabel from '@alltrails/trails/utils/getTrailRouteTypeLabel';
import ExploreServiceFilters from '../../types/ExploreServiceFilters';
import useCheckboxFilterConfig from './useCheckboxFilterConfig';

const routeTypes: TrailRouteType[] = ['O', 'L', 'P'];

export const getValidRouteTypes = (routes: string[]) => routes.filter(route => routeTypes.includes(route as TrailRouteType)) as TrailRouteType[];

const useRouteTypeFilterConfig = (exploreServiceFilters: ExploreServiceFilters, onFiltersChange: (updatedFilters: ExploreServiceFilters) => void) => {
  const intl = useIntl();

  return useCheckboxFilterConfig({
    exploreServiceFilterKey: 'routeType',
    exploreServiceFilters,
    getValueLabel: routeType => getTrailRouteTypeLabel(intl, routeType),
    label: intl.formatMessage({ defaultMessage: 'Route type' }),
    onFiltersChange,
    values: routeTypes
  });
};

export default useRouteTypeFilterConfig;
